import { constants } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";
const {
  colors: { ui },
} = constants;

export const cardCss: CSSObject = {
  backgroundColor: ui.core[25],
  padding: "16px",
  border: "1px solid #85B7FD",
  borderRadius: "16px",
};

export const pdfCardCss: CSSObject = {
  backgroundColor: "unset",
};

export const titleCss: CSSObject = {
  color: ui.core[700],
  margin: "0 0 16px 0",
  lineHeight: "100%",
};

export const subtitleCss: CSSObject = {
  color: ui.core[700],
  margin: "0",
  fontWeight: "bold",
};

export const linksContainerCss: CSSObject = {
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  "> a": {
    whiteSpace: "nowrap",
  },
};
